import { ThemeUIStyleObject } from 'theme-ui';
import { CarrotTheme } from '..';

export type BadgeVariantProp = keyof typeof badges;
export const badges: Record<string, ThemeUIStyleObject> = {
    small: {
        padding: '2px 10px;',
        fontSize: '9px',
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.bolder,
        lineHeight: '18px',
    },
    medium: {
        padding: '6px 10px',
        fontSize: '11px',
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.semibold,
        lineHeight: '16.5px',
        letterSpacing: '0.06em',
    },
};

export default badges;
